import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import Select from "react-select";
import { kitService } from "../../../../../services/kit.services";

class SuggestedKitModal extends Component {
  state = {
    kits: [],
    selectedKit: [],
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen &&
      this.props.kitId &&
      (prevProps.kitId !== this.props.kitId ||
        prevProps.isOpen !== this.props.isOpen)
    ) {
      this.getSuggestedKits();
    }
  }

  getSuggestedKits = async () => {
    this.setState({
      loading: true,
      kits: [],
      selectedKit: [],
    });

    console.log(this.props.kitId, "kitId in SuggestedKitModal");

    try {
      const response = await kitService.getSuggestedKits({
        kitId: this.props.kitId,
      });

      this.setState({
        kits: response.data || [],
        loading: false,
      });

    } catch (e) {
      console.log("error response from getSuggestedKits", e);

      this.setState({
        loading: false,
      });
    }
  };


  handleContinue = () => {
    if (!this.state.selectedKit.length) {
      alert("Please select a kit.");
      return;
    }

    const data = [
      this.props.kitId,
      ...this.state.selectedKit.map(item => item.value)
    ];

    console.log(data, "selected suggested kits");

    this.props.onSelect(data);
  };


  render() {
    const { isOpen, onCancel } = this.props;

    return (
      <Modal isOpen={isOpen} centered backdrop="static">

        <ModalHeader>
          Required Kit
        </ModalHeader>


        <ModalBody>

          <p>
            Please select one or more kits to continue. Neofuse requires one of the following kits. 
          </p>


          <Select
            isMulti
            options={this.state.kits.map((k) => ({
              value: k._id,
              label: k.name,
            }))}
            value={this.state.selectedKit}
            onChange={(selectedKit) =>
              this.setState({
                selectedKit: selectedKit || [],
              })
            }
            isLoading={this.state.loading}
            placeholder="Select Kit"
          />


        </ModalBody>


        <ModalFooter>

          <Button
            color="secondary"
            onClick={onCancel}
          >
            Cancel
          </Button>


          <Button
            color="primary"
            onClick={this.handleContinue}
            disabled={this.state.loading}
          >
            Continue
          </Button>

        </ModalFooter>

      </Modal>
    );
  }
}

export default SuggestedKitModal;